import BaseScene from './BaseScene'
import PlayerMoveToWithSpeed from '../../Animations/Movements/PlayerMoveToWithSpeed'
import { ScorerSpeed, WalkSpeed, BrownianSpeed } from './Constants'
import {randomInteger, calculateDistance, delay} from '../helper'

export default class OwnGoal extends BaseScene {
    constructor(event, pitch) {
        super(pitch);

        this.Team = event.team;
        this.Player = event.player;
        this.Assist = event.assist;

        let keyPoints = pitch.getKeyPoints(this.Team == 1);
        this.CelebrationPoint = keyPoints.celebrationPoint;
    }

    Play(gameSpeed) {
        return new Promise(function(resolve, reject) {
            this.SoundManager.playGoal(this.Team == 1);
            
            let author = this.GetPlayer(this.Team == 1 ? 2 : 1, this.Player);
            let assist = this.GetPlayer(this.Team, this.Assist);

            if(assist != null) {

                this.HighLightPlayers([assist, author]);

                //игроки пропустившей команды: сначала пребывают в ступоре на своих местах рендомное время, а затем плетутся на новые позиции
                this.getPlayersByTeam(this.Team == 1 ? 2 : 1, (p) => p.props.index < 11).forEach((player)=> {
                        player.BrownianMovement(gameSpeed, randomInteger(80, 140))
                        .then(()=> player.WalkToNextPosition(gameSpeed, WalkSpeed))
                        .then(()=> player.BrownianMovement(gameSpeed));
                });

                //автор гола бежит к трибунам праздновать, там проводит рендомное время, затем идет на новую позицию
                let assistMovements = assist.BrownianMovement(gameSpeed, randomInteger(200, 250))
                                            .then(resolve);

                //те кто были в пределах определенного расстояния до автора гола, бегут его поздравить, а потом идут на свои позиции
                let whoWantsToCelebrate = this.getPlayersByTeam(this.Team, (player) => {
                    return player.Id != assist.Id && calculateDistance(player.CurrentPosition, assist.CurrentPosition) < 200;
                });

                whoWantsToCelebrate.forEach((player)=> {
                        player.BrownianMovement(gameSpeed, BrownianSpeed, randomInteger(5, 10)) //задержка
                        .then(() => player.OvertakeOtherPlayer(assist, gameSpeed, ScorerSpeed))
                        .then(() => player.BrownianMovement(gameSpeed, randomInteger(30, 50)))
                        .then(() => player.WalkToNextPosition(gameSpeed, WalkSpeed*2))
                })

                //остальные идут на свои позиции
                this.getPlayersByTeam(this.Team, (player)=> !this.PlayerIn(player, [...whoWantsToCelebrate, assist]))
                    .forEach((player)=> {
                        player.BrownianMovement(gameSpeed, randomInteger(100, 200))
                            .then(()=> player.WalkToNextPosition(gameSpeed, WalkSpeed));
                    });
            } else {
                this.HighLightPlayers([author]);

                this.getPlayers().forEach((player)=> {
                    player.BrownianMovement(gameSpeed, randomInteger(80, 140))
                        .then(()=> player.WalkToNextPosition(gameSpeed, WalkSpeed));
                });

                delay(6000).then(resolve)
            }

        }.bind(this));
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/Animations/Scenes/OwnGoal.js
 **/